export default __webpack_public_path__ + "static/media/logo.4feeb9d7.png";